<template>
  <div class="vuetable-filterbar col-md-12">
    <div class="form-group p-l">
      <b-container fluid class="p-a-0">
        <b-row no-gutters>
          <b-col sm="6" md="2" class="p-a-0">
            <multiselect
              v-model="ufOri"
              :options="optionsUf"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="UF Origem"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0">
            <multiselect
              v-model="ufDes"
              :options="optionsUf"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="UF Destino"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0">
            <multiselect
              v-model="status"
              :options="optionsLivStatus"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Status"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="2">
            <div class="input-group-btn">
              <div class="btn-group">
                <button
                  type="button"
                  class="btn btn-secondary btn-outline"
                  @click="doFilter"
                  :disabled="vuetableFilterButton"
                >
                  Filtrar
                </button>
                <button
                  type="button"
                  class="btn btn-secondary btn-outline"
                  @click="resetFilter"
                  :disabled="vuetableFilterButton"
                >
                  Limpar
                </button>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>
<script>
import Multiselect from "vue-multiselect";
export default {
  components: {
    Multiselect
  },
  data() {
    return {
      helpForm: new Form({ params: [] }),
      optionsLivStatus: [],
      status: [],
      optionsUf: [],
      ufOri: [],
      ufDes: [],
      data_filter: []
    };
  },
  mounted() {
    this.getStatus();
    this.getUf();
  },
  methods: {
    doFilter() {
      this.$store.commit("setVuetableFilterButton", true);
      this.data_filter = {
        uf_id_ori: this.ufOri.value,
        uf_id_des: this.ufDes.value,
        status: this.status
      };
      this.$events.fire("filter-set", this.data_filter);
    },
    resetFilter() {
      this.ufOri = ""; // clear the text in text input
      this.status = "";
      this.ufDes = "";
      this.$events.fire("filter-reset");
    },
    getUf() {
      this.helpForm
        .get("/api/uf/jsonlist")
        .then(response => {
          new ReturnApi(response, this, true, false, false);
          response.items.forEach(obj => {
            this.optionsUf.push({ label: obj.nome, value: obj.uf_id });
          });
        })
        .catch(errors => {
          new ReturnApi(errors, this);
        });
    },
    getStatus() {
      this.helpForm.params = { tabela: "percurso_uf", coluna: "status" };

      this.helpForm
        .get("/api/listitemvalor/jsonlist")
        .then(response => {
          new ReturnApi(response, this, true, false, false);
          response.items.forEach(obj => {
            this.optionsLivStatus.push({ label: obj.descr, value: obj.valor });
          });
        })
        .catch(errors => {
          new ReturnApi(errors, this, true, false, false);
        });
    }
  },
  computed: {
    vuetableFilterButton: {
      get() {
        return this.$store.state.vuetable.filterButton;
      }
    }
  }
};
</script>
